import React, { useCallback, useEffect } from "react";

import { useFormContext } from "react-hook-form";

import { Input } from "@busbud/horizon";

import { useAppContext } from "@app/helpers/hooks";

import { useZipDetails } from "./use-zip-details";
import formatter from "../../../../../../utils/formatter";

export const ZipCodeField: React.FC<{ className?: string }> = ({
  className
}) => {
  const { translator } = useAppContext();

  const {
    register,
    setValue,
    watch,
    formState: { errors }
  } = useFormContext();
  const country_code = watch("country_code");
  const { zip_type, zip_regex, zip_keyboard } = useZipDetails(country_code);

  const formatZipCode = useCallback(
    (value: string) => {
      const formatted_value = formatter.zip(country_code, value);

      setValue("zip_code", formatted_value, {
        shouldValidate: true,
        shouldDirty: true
      });
    },
    [country_code, setValue]
  );

  useEffect(() => {
    if (watch("zip_code")) {
      formatZipCode(watch("zip_code"));
    }
  }, [country_code, formatZipCode, watch]);

  let label = translator.t("!checkout.payment.zip:generic");
  if (zip_type === "cep") {
    label = translator.t("!checkout.payment.zip:cep");
  } else if (zip_type === "postal_code") {
    label = translator.t("!checkout.payment.zip:postal_code");
  } else if (zip_type === "zip_code") {
    label = translator.t("!checkout.payment.zip:zip_code");
  }

  const formatOnChange: React.ChangeEventHandler<HTMLInputElement> = e => {
    return formatZipCode(e.target.value);
  };

  return (
    <Input
      data-testid="zip_code"
      // TODO should probably be type=number instead of type=tel
      type={zip_keyboard === "number_pad" ? "tel" : "text"}
      labelText={label}
      isInvalid={!!errors.zip_code}
      autoComplete="postal-code"
      errorText={errors.zip_code?.message?.toString()}
      className={className}
      {...register("zip_code", {
        required: true,
        onChange: formatOnChange,
        pattern: zip_regex
          ? {
              value: zip_regex,
              message: translator.t(
                "!checkout.passenger-questions.validation-regex.error"
              )
            }
          : undefined
      })}
      isRequired
    />
  );
};
